import React from 'react';
import { connect } from 'react-redux';
import {
  projectCostSelector,
  projectCostLogoUpgradeSelector,
  projectMetadataSelector,
} from '../reducers/selectors';
import { useTranslation, withTranslation } from 'react-i18next';
import styles from './CompleteProject.less';
import {
  getProductText,
  getProjectAuthor,
  getProjectTitle,
} from '../utils/projectUtils';
import Select from 'react-select';
import DropdownIndicator from './DropdownIndicator';
import * as Selectors from '../reducers/selectors';
import * as PicabooConstants from '../common/PicabooConstants';
import { loadPricing } from '../ducks/pricing';

function AddToCartConfirmProject({
  price,
  price_withLogoUpgrade,
  project,
  setUseLogo,
  useLogo,
  projectProduct,
  pricing,
}) {
  const { t } = useTranslation();
  const priceWithoutUpgrade = price ? price : '---';
  const priceWithUpgrade = price_withLogoUpgrade
    ? price_withLogoUpgrade
    : '---';
  const projectUrl = project.get('thumbnailUrl');
  let displayPrice =
    useLogo === PicabooConstants.LOGO_UPGRADE.NONE
      ? priceWithUpgrade
      : priceWithoutUpgrade;
  const setUse = (ss) => {
    setUseLogo(ss.value);
  };
  let productText = getProductText(projectProduct);
  let projectTitle = getProjectTitle(project);
  let projectAuthor = getProjectAuthor(project);

  const projectBlock = (
    <div className={styles.bookVersionThumbnail}>
      <img src={projectUrl} />
      <div className={styles.bookVersionTitle}>{projectTitle}</div>
      <div className={styles.bookVersionAuthor}>
        {t('ADDTOCART.by {{projectAuthor}}', { projectAuthor })}
      </div>
    </div>
  );

  const options = [
    {
      value: PicabooConstants.LOGO_UPGRADE.NONE,
      label: t('ADDTOCART.Remove logo page'),
    },
    {
      value: PicabooConstants.LOGO_UPGRADE.WHITE,
      label: t('ADDTOCART.blurb logo on white page'),
    },
    {
      value: PicabooConstants.LOGO_UPGRADE.BLACK,
      label: t('ADDTOCART.blurb logo on black page'),
    },
  ];

  if (pricing && pricing.error) {
    return (
      <div className={styles.errorContainer}>
        <div className={styles.errorText}>
          {t('ERROR.PRICING_ERROR_ADD_TO_CART')}
        </div>
      </div>
    );
  }

  return (
    <div className={styles.confirmProject}>
      <div className={styles.bookVersionList}>
        <div className={styles.bookVersionHead}>
          <div className={styles.bookVersionHeadColumn1}>
            {t('ADDTOCART.PRINT BOOK VERSION')}
          </div>
          <div className={styles.bookVersionHeadColumn2}>
            {t('ADDTOCART.SPECS')}
          </div>
          <div className={styles.bookVersionHeadColumn3}>
            {t('ADDTOCART.BLURB LOGO PAGE')}
          </div>
          <div className={styles.bookVersionHeadColumn4}>
            {t('ADDTOCART.YOUR BASE PRICE')}
          </div>
        </div>
        <div className={styles.bookVersion}>
          {projectBlock}
          <div className={styles.bookVersionSpecs}>{productText}</div>
          <div className={styles.bookVersionLogo}>
            <Select
              onChange={(e) => setUse(e)}
              options={options}
              value={options.find((option) => option.value === useLogo)}
              defaultValue={useLogo}
              className="react-select-container"
              classNamePrefix="react-select"
              components={{
                IndicatorSeparator: () => null,
                DropdownIndicator,
              }}
              isSearchable={false}
              isClearable={false}
            ></Select>
          </div>
          <div className={styles.bookVersionprice}>{displayPrice}</div>
        </div>
      </div>
    </div>
  );
}

export const withT = withTranslation()(AddToCartConfirmProject);
export default connect((state) => ({
  price: projectCostSelector(state),
  price_withLogoUpgrade: projectCostLogoUpgradeSelector(state),
  project: projectMetadataSelector(state),
  projectProduct: Selectors.projectProductSelector(state),
  pricing: Selectors.pricingSelector(state),
}))(withT);
